"use strict";

const gaEvents = () => {
    const init = () => {
        // pdfDownload();
        telClick();
        // mailToClick();
        // formSubmit();
        // iframeLoad();
    };

    const findParam = (name) => {
        let result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === name) result = decodeURIComponent(tmp[1]);
            });
        return result;
    };

    const pdfDownload = () => {
        // $('a[target="_blank"]').click(function(){
        //     var str = $(this).attr('href');
        //     if (str.indexOf('.pdf') >= 0){
        //         window.dataLayer = window.dataLayer || [];
        //         window.dataLayer.push({
        //             'event': 'pdf_downloaded',
        //             'event_label': $(location).attr('pathname') + $(location).attr('search')
        //         });
        //     }else{
        //         //offsite link
        //     }
        // });
    };

    const telClick = () => {
        $('a[href^="tel:"]').click(function(){

            $.request('zimpleGlobals::onSendFacebookContact', {
                data: {
                    consent: localStorage.getItem('cookie_consent')
                },
                success: function (result_data) {
                    // console.log('Contact tracked');
                },
                error: function (result_data) {
                    // console.log('Contact error');
                }
            });

            // var t = $(this).parent();
            // while(!t[0].hasAttribute('id') && !t.is('body')){
            //     t = t.parent();
            // }
            // if(t[0].hasAttribute('id')){
            //     var id = t.attr('id');
            // }else{
            //     var id = 'body';
            // }
            // var event_data = {
            //     'event_category': 'ENQUIRY',
            //     'event_label': id+' tel '+$(location).attr('pathname')+$(location).attr('search')
            // };
            //
            // event_data['event'] = 'tel_link_clicked';
            // window.dataLayer = window.dataLayer || [];
            // window.dataLayer.push(event_data);
        });
    };

    const mailToClick = () => {
        // $('a[href^="mailto:"]').click(function(){
        //     var t = $(this).parent();
        //     while(!t[0].hasAttribute('id') && !t.is('body')){
        //         t = t.parent();
        //     }
        //     if(t[0].hasAttribute('id')){
        //         var id = t.attr('id');
        //     }else{
        //         var id = 'body';
        //     }
        //     gtag('event', 'ENGAGED', {
        //         'event_category': 'ENQUIRY',
        //         'event_label': id + ' mailto ' + $(location).attr('pathname') + $(location).attr('search')
        //     });
        // });
    };

    const formSubmit = () => {
        // $('form').submit(function(){
        //     let context;
        //     let action = $(this).attr('action');
        //     if (action) {
        //         action = action.split('?');
        //         if(action.length > 1){
        //             context = action[1];
        //         }else{
        //             context = action[0];
        //         }
        //         gtag('event', 'SUBMITTED', {
        //             'event_category': 'ENQUIRY',
        //             'event_label': 'form submitted ' + context + ' ' + $(location).attr('pathname') + $(location).attr('search')
        //         });
        //     }
        // });
    };

    const iframeLoad = () => {
        // $('iframe').on('load', function(){
        //     if($(this).attr('src') != ''){
        //         gtag('event', 'VIEWED', {
        //             'event_category': 'MEDIA',
        //             'event_label': 'iframe viewed ' + $(this).attr('src') + ' ' + $(location).attr('pathname') + $(location).attr('search')
        //         });
        //     }
        // });
    };

    const onFormSuccess = (form) => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            'event': 'form_success_trigger',
            'form_id': $(form).attr('data-form-id')
        });

        if (typeof vgo !== 'undefined') {
            if($(form).find('[name="email"]').length > 0 && $(form).find('[name="email"]').val().length > 0) {
                vgo('setEmail', $(form).find('[name="email"]').val());
                vgo('process');
                //console.log('vgo email logged');
            }
        }

        if($(form).attr('data-form-id') == 'catalogue-download-form' && $(location).attr('pathname') == '/catalogue/') {
            window.dataLayer.push({
                'event': 'catalogue_subscribe_trigger',
                'form_id': $(form).attr('data-form-id')
            });
        }else if($(form).attr('data-form-id') == 'quote-form-single-step-studio-shed') {
            window.dataLayer.push({
                'event': 'studio_quote_trigger',
            });
        }else if($(form).attr('data-form-id') == 'newsletter-form') {
            window.dataLayer.push({
                'event': 'newsletter_trigger',
            });
        }else if($(form).attr('data-form-id') == 'become-agent-form') {
            window.dataLayer.push({
                'event': 'register_interest_agent',
            });
        }
    };

    const onQuoteFormStepOneFormSuccess = (form) => {
        // User performs a "click" on the "next" button on quote request form, any page
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'quote_form_next_trigger'});
    };

    const updateConsent = ($button, status) => {
        gtag('consent', 'update', {
            'ad_storage': status,
            'analytics_storage': status,
            'ad_user_data': status,
            'ad_personalization': status
        });
        localStorage.setItem('cookie_consent', status);

        if($button.attr('data-meta-consent-enabled').length > 0 && status == 'granted') {
            fbq('consent', 'grant');
        }
    };

    const onQuoteFormStepTwoFormSuccess = (form) => {
        window.dataLayer = window.dataLayer || [];

        if($(form).find('[name="high_value_agent"]').length > 0 && $(form).find('[name="high_value_agent"]').val().length > 0){
            // User successfully submits a quote request via the Contact Agent form on agents page
            window.dataLayer.push({'event': 'contact_agent_trigger'});
        } else {
            if($(form).find('[name="quote_type"]').length > 0 && $(form).find('[name="quote_type"]').val().length > 0){
                var quote_type = $(form).find('[name="quote_type"]').val();
                var event_name = '';

                if (quote_type == 'shed') {
                    var width = $(form).find('[name="width"]').val();
                    var length = $(form).find('[name="length"]').val();
                    event_name = 'sheds_quote';

                    if(width.length > 0 && length.length > 0) {
                        var square_m = width * length;

                        if(square_m < 24) {
                            event_name = 'garden_sheds_quote';
                        }
                    }
                } else if (quote_type == 'carport') {
                    event_name = 'carport_quote';
                } else if (quote_type == 'commercial_building') {
                    event_name = 'commercial_building_quote'; 
                } else if (quote_type == 'kit_home') {
                    event_name = 'kit_home_quote';
                } else if (quote_type == 'liveable_shed') {
                    event_name = 'liveable_quote';
                } 
                else if (quote_type == 'metal_workshop') {
                    event_name = 'metal_workshop_quote';
                } else if (quote_type == 'farm_building') {
                    event_name = 'farm_building_quote';
                } else if (quote_type == 'metal_building') {
                    event_name = 'metal_building_quote';
                } else { 
                    event_name = quote_type + '_quote';
                }

                if (event_name.length > 0) {
                    window.dataLayer.push({'event': event_name + '_trigger'});
                }
            }
        }

        $.request('zimpleGlobals::onSendFacebookLead', {
            data: {
                consent: localStorage.getItem('cookie_consent')
            },
            success: function (result_data) {
                // console.log('Lead tracked');
            },
            error: function (result_data) {
                // console.log('Lead error');
            }
        });
    };

    return {
        init: init,
        onFormSuccess: onFormSuccess,
        onQuoteFormStepOneFormSuccess: onQuoteFormStepOneFormSuccess,
        onQuoteFormStepTwoFormSuccess: onQuoteFormStepTwoFormSuccess,
        updateConsent: updateConsent,
    };
};

export default gaEvents;